import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { Section } from '../../GlobalStyles'
import styled from 'styled-components'
import Author from '../../../images/Home/author2.png'

export const TestimonialsWrapper = styled(Section)`
  background-color: ${p => p.theme.colors.white};
  @media (min-width: 1025px) {
    padding: 150px 0;
  }
`

export const TextContainer = styled.div`
  text-align: center;
`

export const Blockquote = styled.div`
  text-align: center;
  font-size: 30px;
  font-style: italic;
  font-weight: 300;
  margin-bottom: 20px;
`
export const Cite = styled.div`
  text-align: center;
  font-size: 21px;
  font-style: italic;
  font-weight: 300;
  margin-bottom: 30px;
`
export const TestimonialsSecondary = () => {
  return (
    <TestimonialsWrapper>
      <Container>
        <Row>
          <TextContainer as={Col} xs='12' md={{ size: 10, offset: 1 }}>
            <Blockquote>
              “ADM does a great job of reinforcing what a lot of us have already
              been doing, but brings it to the forefront for all coaches. I have
              been through far too many PGA educations to count and this one was
              by FAR the best from a content, production value, assessment etc.
              Head and shoulder above anything else.”
            </Blockquote>
            <Cite>
              - Cameron Milton, Head Golf Professional at Polson (Montana) Bay
              Golf Course, 2018 PGA Youth Player Development Award Winner.
            </Cite>
            <img src={Author} alt='Pga Coach' width='112' />
          </TextContainer>
        </Row>
      </Container>
    </TestimonialsWrapper>
  )
}

export default TestimonialsSecondary
